import React from "react";

const PATHS = {
  spring: (
    <>
      <path d="M16 27V15" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M16 18c0-4.5-3-7-7.5-7.2C8.7 15.3 11.5 18 16 18Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M16 15c0-4.5 3-7 7.5-7.2C23.3 12.3 20.5 15 16 15Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M11 27h10" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </>
  ),
  summer: (
    <>
      <circle cx="16" cy="16" r="6" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M16 4v3.2M16 24.8V28M28 16h-3.2M7.2 16H4M24.5 7.5l-2.3 2.3M9.8 22.2l-2.3 2.3M24.5 24.5l-2.3-2.3M9.8 9.8 7.5 7.5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </>
  ),
  autumn: (
    <>
      <path
        d="M16 6c5 1.5 8 5.4 8 10 0 4.5-3.6 8-8 8s-8-3.5-8-8c0-4.6 3-8.5 8-10Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
      <path d="M16 6v18M16 13c-2.2 0-4-1-5.3-2.6M16 18c2.4 0 4.4-1.1 5.8-2.9" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <path d="M16 24v4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </>
  ),
  winter: (
    <>
      <path d="M16 5v22M6.5 10.5l19 11M6.5 21.5l19-11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="16" cy="5" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="16" cy="27" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="6.5" cy="10.5" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="25.5" cy="21.5" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="25.5" cy="10.5" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="6.5" cy="21.5" r="1.15" fill="currentColor" stroke="none" />
    </>
  ),
};

function SeasonIcon({ season, size = 32, color = "var(--gold-deep)", className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
      role="img"
      aria-hidden="true"
    >
      {PATHS[season]}
    </svg>
  );
}

export default SeasonIcon;
